export default __webpack_public_path__ + "static/media/hc-4.5d518f55.mp4";